import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink } from "lucide-react";
import { API } from "../../config";

export const CustomerRefCards = ({ visit }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/web-design/references`).then((r) => setRows(r.data.rows)).catch(() => {}); }, []);
  return rows.map((r) => (
    <article key={r.id} className="group rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden hover:border-[#a3e635]/50 transition-colors" data-testid={`web-cref-${r.id}`}>
      <a href={r.url} target="_blank" rel="noopener noreferrer" className="block overflow-hidden" data-testid={`web-cref-img-link-${r.id}`}>
        <img src={`${API}/web-design/references/${r.id}/image`} alt={r.name} loading="lazy" className="w-full aspect-[16/10] object-cover object-top group-hover:scale-[1.03] transition-transform duration-500" /></a>
      <div className="p-5 flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-lg font-black text-white"><a href={r.url} target="_blank" rel="noopener noreferrer" className="hover:text-[#a3e635]" data-testid={`web-cref-name-link-${r.id}`}>{r.name}</a></h3>
        <a href={r.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm font-bold text-white hover:text-[#a3e635]" data-testid={`web-cref-visit-${r.id}`}>{visit}<ExternalLink className="w-3.5 h-3.5" /></a>
      </div>
    </article>
  ));
};
